/* ============================================================================
FILE: po-katupirsia5-sceau-d-ife-texts-fr-en-es-20260307.js

MODE: TRILINGUE (FR/EN/ES) + lexicon injection (if present)

API:  window.PoKatupirsia5SceauDIfeTextsFR_EN_ES_20260307

ROOT: .po-axis-section[data-po-axis]

ROLE:
  - Injecte le contenu FR/EN/ES dans les slots selon la langue (navigateur ou storage).
  - Protection fine: verrouille (translate="no") TOUTES les occurrences du lexique simplifié (si disponible),
    avec variantes apostrophes + œ/oe, et anti-collage (espaces DOM/HTML uniquement quand nécessaire).
  - IMPORTANT: les termes du lexique (et variantes) restent en FR, quelle que soit la langue affichée.
  - Compat: conserve un alias API window.GoodyTwinLang (getLang/setLang/init) pour éviter de casser d’anciens appels.
  - Ajoute une couche audio locale et générale sans toucher au socle multilingue, au nom du fichier,
    ni aux protections lexicales.
============================================================================ */

(function(){

  "use strict";

  if (window.__PO_KATUPIRSIA5_SCEAU_D_IFE_TEXTS_20260307__) return;
  window.__PO_KATUPIRSIA5_SCEAU_D_IFE_TEXTS_20260307__ = true;

  window.__POLEX_RUNTIME_INIT__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var ROOT_SEL = '.po-axis-section[data-po-axis]';
  var AXIS_LEX_ID = "sceau_d_ife";

  function clampStr(v){ return (v == null) ? "" : String(v); }

  function normLang(raw){
    var v = (raw == null) ? "" : String(raw);
    v = v.toLowerCase().trim();
    if (v.indexOf("fr") === 0) return "fr";
    if (v.indexOf("en") === 0) return "en";
    if (v.indexOf("es") === 0) return "es";
    return "";
  }

  function readStoredLang(){
    try{
      var v = localStorage.getItem(STORAGE_KEY);
      v = normLang(v);
      if (v) return v;
    }catch(e){}
    try{
      var v2 = localStorage.getItem(STORAGE_KEY_COMPAT);
      v2 = normLang(v2);
      if (v2) return v2;
    }catch(e){}
    return "";
  }

  function storeLang(lang){
    var v = normLang(lang) || "fr";
    try{ localStorage.setItem(STORAGE_KEY, v); }catch(e){}
    try{ localStorage.setItem(STORAGE_KEY_COMPAT, v); }catch(e){}
    try{ document.documentElement.setAttribute("lang", v); }catch(e){}
  }

  function detectBrowserLang(){
    try{
      var n = (navigator && (navigator.language || (navigator.languages && navigator.languages[0]))) || "";
      var v = normLang(n);
      if (v) return v;
    }catch(e){}
    return "fr";
  }

  function getLang(){
    return readStoredLang() || detectBrowserLang() || "fr";
  }

  function notifyLocaleChanged(){
    try{
      window.dispatchEvent(new Event("po:locale-changed"));
    }catch(e){
      try{
        var ev = document.createEvent("Event");
        ev.initEvent("po:locale-changed", true, true);
        window.dispatchEvent(ev);
      }catch(_e){}
    }
  }

  /* --------------------------------------------------------------------------
   * LEXIQUE RUNTIME (source canonique prioritaire)
   * -------------------------------------------------------------------------- */

  function getLexiconEntry(id){
    try{
      if (window.PO_LEXICON_MAP && window.PO_LEXICON_MAP[id]) return window.PO_LEXICON_MAP[id];
    }catch(e){}

    try{
      var arr = window.PO_LEXICON;
      if (Array.isArray(arr)){
        for (var i=0;i<arr.length;i++){
          if (arr[i] && arr[i].id === id) return arr[i];
        }
      }
    }catch(e){}

    return null;
  }

  function pickTerm(entry, lang){
    if (!entry) return "";
    try{
      if (entry.terms && entry.terms[lang]) return clampStr(entry.terms[lang]);
    }catch(e){}
    return "";
  }

  function pickDefShort(entry, lang){
    if (!entry) return "";
    var ks = "definition_short_" + lang;
    var k  = "definition_" + lang;
    try{
      if (entry[ks]) return clampStr(entry[ks]);
      if (entry[k])  return clampStr(entry[k]);
    }catch(e){}
    return "";
  }

  function pickDefLong(entry, lang){
    if (!entry) return "";
    var kl = "definition_long_" + lang;
    var k  = "definition_" + lang;
    try{
      if (entry[kl]) return clampStr(entry[kl]);
      if (entry[k])  return clampStr(entry[k]);
    }catch(e){}
    return "";
  }

  function pickArray(entry, lang, base){
    if (!entry) return [];
    var k = base + "_" + lang;
    try{
      var v = entry[k];
      if (Array.isArray(v)) return v;
    }catch(e){}
    return [];
  }

  /* --------------------------------------------------------------------------
   * PROTECTION fine (lexique simplifié PRIORITAIRE) + anti-collage
   * -------------------------------------------------------------------------- */

  function protectSpan(txt){
    return '<span translate="no" class="po-lex-protect">' + clampStr(txt) + "</span>";
  }

  function uniqPush(arr, v){
    if (!v) return;
    for (var i=0;i<arr.length;i++){
      if (arr[i] === v) return;
    }
    arr.push(v);
  }

  function buildVariants(term){
    var out = [];
    var t = clampStr(term);
    if (!t) return out;

    uniqPush(out, t);

    var a1 = t.replace(/’/g, "'");
    var a2 = t.replace(/'/g, "’");
    uniqPush(out, a1);
    uniqPush(out, a2);

    var oe1 = t.replace(/œ/g, "oe").replace(/Œ/g, "OE");
    uniqPush(out, oe1);

    var oe2 = t.replace(/oe/g, "œ").replace(/OE/g, "Œ");
    uniqPush(out, oe2);

    uniqPush(out, oe1.replace(/’/g, "'"));
    uniqPush(out, oe1.replace(/'/g, "’"));
    uniqPush(out, oe2.replace(/’/g, "'"));
    uniqPush(out, oe2.replace(/'/g, "’"));

    return out;
  }

  function getSimplifiedLexiqueFRList(){
    try{
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)){
        return window.PO_LEXICON_META.lexique_simplifie_fr.slice();
      }
    }catch(e){}

    try{
      if (window.PO_LEXICON && window.PO_LEXICON.meta && Array.isArray(window.PO_LEXICON.meta.lexique_simplifie_fr)){
        return window.PO_LEXICON.meta.lexique_simplifie_fr.slice();
      }
    }catch(e){}

    try{
      if (window.PO_LEXIQUE_SIMPLIFIE && window.PO_LEXIQUE_SIMPLIFIE.meta &&
          Array.isArray(window.PO_LEXIQUE_SIMPLIFIE.meta.lexique_simplifie_fr)){
        return window.PO_LEXIQUE_SIMPLIFIE.meta.lexique_simplifie_fr.slice();
      }
    }catch(e){}

    try{
      if (Array.isArray(window.PO_LEXIQUE_SIMPLIFIE_FR)){
        return window.PO_LEXIQUE_SIMPLIFIE_FR.slice();
      }
    }catch(e){}

    return [
      "Sceau d’Ifẹ̀",
      "Sceau d’Ìfẹ",
      "Ifẹ̀",
      "Ìfẹ́",
      "Ifẹ̀riya",
      "Posœnnoïsme",
      "Posœnnoïa",
      "Organon posœnnoïal",
      "Katûvýsissence",
      "Katûvýs",
      "Ennéagone",
      "Ennéagone régulateur",
      "Threnisqun",
      "Isqun",
      "Posœnnomia",
      "RéZonans",
      "Péroptissimisme",
      "Aliœvolution",
      "Illusion",
      "Addition synchrêtique",
      "Instantané multiple",
      "Superposition de perspectives",
      "Sujet pluriel",
      "Humanus",
      "Balakallpa",
      "Katûsýs",
      "Katûvýsqun",
      "Katûpirsia",
      "Accords Posœnnoïaux",
      "Méditations Posœnnoïales"
    ];
  }

  function escapeRegExp(s){
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function buildProtectMatcher(){
    var base = getSimplifiedLexiqueFRList();
    var variants = [];

    for (var i=0;i<base.length;i++){
      var vlist = buildVariants(base[i]);
      for (var j=0;j<vlist.length;j++){
        uniqPush(variants, vlist[j]);
      }
    }

    variants.sort(function(a,b){ return b.length - a.length; });

    var parts = [];
    for (var k=0;k<variants.length;k++){
      if (!variants[k]) continue;
      parts.push(escapeRegExp(variants[k]));
    }
    if (!parts.length) return null;

    try{
      return new RegExp("(" + parts.join("|") + ")", "g");
    }catch(e){
      return null;
    }
  }

  var __PO_PROTECT_RE__ = null;

  function protectKeywordsHTML(html){
    if (!html) return "";
    var out = String(html);

    if (!__PO_PROTECT_RE__){
      __PO_PROTECT_RE__ = buildProtectMatcher();
    }
    if (__PO_PROTECT_RE__){
      out = out.replace(__PO_PROTECT_RE__, function(m){
        return protectSpan(m);
      });
    }

    out = out.replace(/([0-9A-Za-zÀ-ÖØ-öø-ÿ])(<span translate="no" class="po-lex-protect">)/g, "$1 $2");
    out = out.replace(/(<\/span>)([0-9A-Za-zÀ-ÖØ-öø-ÿ])/g, "$1 $2");
    out = out.replace(/(<\/span>)(<[^\/\s>])/g, "$1 $2");
    out = out.replace(/([^\s>])(<span translate="no" class="po-lex-protect">)/g, function(_m, a, b){
      if (a === " " || a === ">") return a + b;
      return a + " " + b;
    });

    return out;
  }

  /* --------------------------------------------------------------------------
   * AUDIO LOCAL PAR BLOC + TEXTE GÉNÉRAL
   * -------------------------------------------------------------------------- */

  var PO_AUDIO_SYNTH = (typeof window !== "undefined" && window.speechSynthesis) ? window.speechSynthesis : null;
  var PO_AUDIO_STATE = {
    root: null,
    units: [],
    unitPos: -1,
    chunks: [],
    chunkPos: -1,
    activeKey: "",
    lang: "fr",
    voice: null
  };

  var AUDIO_UI = {
    fr: { general: "Écouter le texte", block: "Écouter ce bloc", stop: "Arrêter la lecture" },
    en: { general: "Listen to the text", block: "Listen to this section", stop: "Stop playback" },
    es: { general: "Escuchar el texto", block: "Escuchar este bloque", stop: "Detener la lectura" }
  };

  function audioUI(lang){
    var L = normLang(lang);
    return AUDIO_UI[L] || AUDIO_UI.fr;
  }

  function isThisAxisRoot(root){
    return !!(root && getAxisLexId(root) === AXIS_LEX_ID);
  }

  function getAudioRoots(){
    var all = [];
    try{ all = document.querySelectorAll(ROOT_SEL); }catch(e){ return []; }
    var out = [];
    for (var i=0;i<all.length;i++){
      if (isThisAxisRoot(all[i])) out.push(all[i]);
    }
    return out;
  }

  function getDetailBlocks(root){
    if (!root || !root.querySelectorAll) return [];
    try{ return root.querySelectorAll(".po-lex-details"); }catch(e){ return []; }
  }

  function ensureAudioStyles(){
    if (document.getElementById("po-axis-audio-styles")) return;
    var style = document.createElement("style");
    style.id = "po-axis-audio-styles";
    style.textContent =
      ".po-axis-audio-wrap{display:flex;align-items:center;gap:.6rem;margin:1rem 0 1.15rem 0;justify-content:flex-start;}" +
      ".po-axis-audio-btn{appearance:none;-webkit-appearance:none;border:1px solid rgba(184,134,11,.55);background:rgba(31,122,58,.04);color:var(--color-accent,#1f7a3a);padding:.55rem .9rem;border-radius:999px;cursor:pointer;font:inherit;font-weight:800;line-height:1.2;transition:opacity .2s ease,transform .2s ease,box-shadow .2s ease,border-color .2s ease;box-shadow:0 6px 16px rgba(31,122,58,.10);}" +
      ".po-axis-audio-btn:hover{transform:translateY(-1px);box-shadow:0 10px 26px rgba(31,122,58,.16);border-color:rgba(184,134,11,.75);}" +
      ".po-axis-audio-btn[aria-pressed='true']{box-shadow:0 0 0 1px rgba(184,134,11,.18),0 10px 26px rgba(31,122,58,.18);background:rgba(31,122,58,.08);}" +
      ".po-lex-summary .po-axis-audio-btn{margin-left:.75rem;vertical-align:middle;flex:0 0 auto;}" +
      "@media (max-width:640px){.po-lex-summary{flex-wrap:wrap;}.po-lex-summary .po-axis-audio-btn{display:block;margin:.65rem 0 0 0;}}";
    document.head.appendChild(style);
  }

  function createAudioButton(role){
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "po-axis-audio-btn";
    btn.setAttribute("data-po-audio-role", role === "general" ? "general" : "detail");
    btn.setAttribute("aria-pressed", "false");
    btn.setAttribute("translate", "yes");
    return btn;
  }

  function ensureAudioButtons(root){
    if (!root) return;
    ensureAudioStyles();

    var panel = root.querySelector(".po-lex-panel");
    if (panel){
      var generalWrap = root.querySelector(".po-axis-audio-wrap[data-po-audio-role='general']");
      if (!generalWrap){
        generalWrap = document.createElement("div");
        generalWrap.className = "po-axis-audio-wrap";
        generalWrap.setAttribute("data-po-audio-role", "general");

        var generalBtn = createAudioButton("general");
        generalWrap.appendChild(generalBtn);

        var meta = root.querySelector(".po-axis-meta");
        var defShort = root.querySelector("[data-po-slot='def_short']");
        var firstDetail = panel.querySelector(".po-lex-details");

        if (meta && meta.parentNode){
          if (meta.nextSibling) meta.parentNode.insertBefore(generalWrap, meta.nextSibling);
          else meta.parentNode.appendChild(generalWrap);
        } else if (defShort && defShort.parentNode){
          defShort.parentNode.insertBefore(generalWrap, defShort);
        } else if (firstDetail && firstDetail.parentNode){
          firstDetail.parentNode.insertBefore(generalWrap, firstDetail);
        } else {
          panel.appendChild(generalWrap);
        }
      }
    }

    var details = getDetailBlocks(root);
    for (var i=0;i<details.length;i++){
      var detail = details[i];
      var summary = detail.querySelector(".po-lex-summary");
      if (!summary) continue;

      var btn = summary.querySelector(".po-axis-audio-btn[data-po-audio-role='detail']");
      if (!btn){
        btn = createAudioButton("detail");
        summary.appendChild(btn);
      }
      btn.setAttribute("data-po-audio-index", String(i));
    }
  }

  function getTextValue(el){
    if (!el) return "";
    var txt = "";
    try{ txt = el.innerText || el.textContent || ""; }catch(e){ txt = ""; }
    txt = String(txt).replace(/\s+/g, " ").replace(/\u00a0/g, " ").trim();
    return txt;
  }

  function removeAudioButtonsFromClone(root){
    if (!root || !root.querySelectorAll) return;
    var btns = root.querySelectorAll(".po-axis-audio-btn, .po-axis-audio-wrap");
    for (var i=0;i<btns.length;i++){
      var btn = btns[i];
      if (btn && btn.parentNode) btn.parentNode.removeChild(btn);
    }
  }

  function collectGeneralText(root){
    var parts = [];
    var slots = ["title", "kicker", "h_def", "def_short", "def_long"];
    for (var i=0;i<slots.length;i++){
      var el = root.querySelector("[data-po-slot='" + slots[i] + "']");
      var txt = getTextValue(el);
      if (txt) parts.push(txt);
    }
    return parts.join(". ");
  }

  function collectDetailText(detail){
    if (!detail) return "";
    var parts = [];

    var title = detail.querySelector(".po-lex-summary__title");
    var titleText = getTextValue(title);
    if (titleText) parts.push(titleText);

    var clone = detail.cloneNode(true);
    var summary = clone.querySelector(".po-lex-summary");
    if (summary && summary.parentNode) summary.parentNode.removeChild(summary);
    removeAudioButtonsFromClone(clone);

    var bodyText = getTextValue(clone);
    if (bodyText) parts.push(bodyText);

    return parts.join(". ");
  }

  function isWordLikeChar(ch){
    return /[0-9A-Za-zÀ-ÖØ-öø-ÿ]/.test(ch || "");
  }

  function splitTextForSpeech(txt, maxLen){
    var text = clampStr(txt).replace(/\s+/g, " ").trim();
    if (!text) return [];
    var limit = Math.max(120, parseInt(maxLen, 10) || 200);
    var out = [];
    var start = 0;

    while (start < text.length){
      var end = Math.min(start + limit, text.length);
      if (end < text.length){
        var slice = text.slice(start, end);
        var cut = Math.max(
          slice.lastIndexOf(". "),
          slice.lastIndexOf("! "),
          slice.lastIndexOf("? "),
          slice.lastIndexOf("; "),
          slice.lastIndexOf(": "),
          slice.lastIndexOf(", ")
        );
        if (cut < Math.floor(limit * 0.55)){
          cut = slice.lastIndexOf(" ");
        }
        if (cut > 0) end = start + cut + 1;
      }

      while (end < text.length && isWordLikeChar(text.charAt(end - 1)) && isWordLikeChar(text.charAt(end))){
        end++;
      }

      var chunk = text.slice(start, end).trim();
      if (chunk) out.push(chunk);
      start = end;
    }

    return out;
  }

  function pickVoiceForLang(lang){
    if (!PO_AUDIO_SYNTH || typeof PO_AUDIO_SYNTH.getVoices !== "function") return null;
    var wanted = normLang(lang) || "fr";
    var voices = [];
    try{ voices = PO_AUDIO_SYNTH.getVoices() || []; }catch(e){ voices = []; }
    if (!voices.length) return null;

    var i, v, voiceLang;
    for (i=0;i<voices.length;i++){
      v = voices[i];
      voiceLang = normLang(v && v.lang);
      if (voiceLang === wanted) return v;
    }
    for (i=0;i<voices.length;i++){
      v = voices[i];
      voiceLang = clampStr(v && v.lang).toLowerCase();
      if (voiceLang.indexOf(wanted) === 0) return v;
    }
    return voices[0] || null;
  }

  function buildUnits(root, role, index){
    var units = [];
    var details = getDetailBlocks(root);

    if (role === "general"){
      units.push({ role: "general", index: -1 });
      for (var i=0;i<details.length;i++){
        units.push({ role: "detail", index: i });
      }
      return units;
    }

    var start = (typeof index === "number" && index >= 0) ? index : 0;
    for (var j=start;j<details.length;j++){
      units.push({ role: "detail", index: j });
    }
    return units;
  }

  function updateAudioPressedState(){
    var roots = getAudioRoots();
    for (var i=0;i<roots.length;i++){
      var root = roots[i];
      var btns = root.querySelectorAll(".po-axis-audio-btn");
      for (var j=0;j<btns.length;j++){
        btns[j].setAttribute("aria-pressed", "false");
      }
    }

    if (!PO_AUDIO_STATE.root || !PO_AUDIO_STATE.activeKey) return;

    var btn;
    if (PO_AUDIO_STATE.activeKey === "general"){
      btn = PO_AUDIO_STATE.root.querySelector(".po-axis-audio-wrap[data-po-audio-role='general'] .po-axis-audio-btn[data-po-audio-role='general']");
      if (btn) btn.setAttribute("aria-pressed", "true");
      return;
    }

    var idx = parseInt(String(PO_AUDIO_STATE.activeKey).split(":")[1], 10);
    if (!isNaN(idx)){
      btn = PO_AUDIO_STATE.root.querySelector(".po-axis-audio-btn[data-po-audio-role='detail'][data-po-audio-index='" + idx + "']");
      if (btn) btn.setAttribute("aria-pressed", "true");
    }
  }

  function refreshAudioLabels(root, lang){
    if (!root) return;
    var ui = audioUI(lang || getLang());

    var generalBtn = root.querySelector(".po-axis-audio-wrap[data-po-audio-role='general'] .po-axis-audio-btn[data-po-audio-role='general']");
    if (generalBtn){
      var generalActive = (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === "general" && PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending));
      generalBtn.textContent = generalActive ? ui.stop : ui.general;
    }

    var detailBtns = root.querySelectorAll(".po-axis-audio-btn[data-po-audio-role='detail']");
    for (var i=0;i<detailBtns.length;i++){
      var btn = detailBtns[i];
      var idx = parseInt(btn.getAttribute("data-po-audio-index"), 10);
      var key = "detail:" + (isNaN(idx) ? -1 : idx);
      var active = (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === key && PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending));
      btn.textContent = active ? ui.stop : ui.block;
    }

    updateAudioPressedState();
  }

  function refreshAllAudioLabels(lang){
    var roots = getAudioRoots();
    for (var i=0;i<roots.length;i++){
      refreshAudioLabels(roots[i], lang || getLang());
    }
  }

  function stopAudio(silent){
    if (PO_AUDIO_SYNTH){
      try{ PO_AUDIO_SYNTH.cancel(); }catch(e){}
    }
    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = "";
    PO_AUDIO_STATE.voice = null;
    if (!silent) refreshAllAudioLabels(getLang());
    else updateAudioPressedState();
  }

  function speakCurrentChunk(){
    if (!PO_AUDIO_SYNTH) return;

    if (!PO_AUDIO_STATE.chunks.length || PO_AUDIO_STATE.chunkPos < 0 || PO_AUDIO_STATE.chunkPos >= PO_AUDIO_STATE.chunks.length){
      PO_AUDIO_STATE.unitPos += 1;
      playCurrentUnit(true);
      return;
    }

    var txt = PO_AUDIO_STATE.chunks[PO_AUDIO_STATE.chunkPos];
    if (!txt){
      PO_AUDIO_STATE.chunkPos += 1;
      speakCurrentChunk();
      return;
    }

    var utter = new SpeechSynthesisUtterance(txt);
    utter.lang = (PO_AUDIO_STATE.lang || getLang() || "fr");
    if (PO_AUDIO_STATE.voice) utter.voice = PO_AUDIO_STATE.voice;

    utter.onend = function(){
      PO_AUDIO_STATE.chunkPos += 1;
      speakCurrentChunk();
    };

    utter.onerror = function(){
      PO_AUDIO_STATE.chunkPos += 1;
      speakCurrentChunk();
    };

    try{ PO_AUDIO_SYNTH.speak(utter); }catch(e){
      PO_AUDIO_STATE.chunkPos += 1;
      speakCurrentChunk();
    }
  }

  function playCurrentUnit(skipCancel){
    if (!PO_AUDIO_SYNTH) return;

    if (!skipCancel){
      try{ PO_AUDIO_SYNTH.cancel(); }catch(e){}
    }

    if (!PO_AUDIO_STATE.root || PO_AUDIO_STATE.unitPos < 0 || PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length){
      stopAudio();
      return;
    }

    var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
    if (!unit){
      stopAudio();
      return;
    }

    var text = "";
    if (unit.role === "general"){
      PO_AUDIO_STATE.activeKey = "general";
      text = collectGeneralText(PO_AUDIO_STATE.root);
    } else {
      PO_AUDIO_STATE.activeKey = "detail:" + unit.index;
      var details = getDetailBlocks(PO_AUDIO_STATE.root);
      var detail = details[unit.index];
      if (detail){
        try{ detail.open = true; }catch(e){}
      }
      text = collectDetailText(detail);
    }

    PO_AUDIO_STATE.chunks = splitTextForSpeech(text, 210);
    PO_AUDIO_STATE.chunkPos = 0;
    refreshAllAudioLabels(PO_AUDIO_STATE.lang || getLang());

    if (!PO_AUDIO_STATE.chunks.length){
      PO_AUDIO_STATE.unitPos += 1;
      playCurrentUnit(true);
      return;
    }

    speakCurrentChunk();
  }

  function startAudio(root, role, index){
    if (!PO_AUDIO_SYNTH || !root) return;
    stopAudio(true);

    var lang = getLang();

    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.units = buildUnits(root, role, index);
    PO_AUDIO_STATE.unitPos = 0;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = "";
    PO_AUDIO_STATE.lang = lang;
    PO_AUDIO_STATE.voice = pickVoiceForLang(lang);

    refreshAllAudioLabels(lang);
    playCurrentUnit(false);
  }

  function bindAudioButtons(root){
    if (!root) return;
    var btns = root.querySelectorAll(".po-axis-audio-btn");
    for (var i=0;i<btns.length;i++){
      var btn = btns[i];
      if (btn.__poAudioBound) continue;

      btn.addEventListener("click", function(ev){
        ev.preventDefault();
        ev.stopPropagation();

        var role = this.getAttribute("data-po-audio-role") || "detail";
        var index = parseInt(this.getAttribute("data-po-audio-index"), 10);
        var key = (role === "general") ? "general" : ("detail:" + (isNaN(index) ? -1 : index));
        var sameRoot = (PO_AUDIO_STATE.root === root);
        var sameKey = (PO_AUDIO_STATE.activeKey === key);

        if (sameRoot && sameKey && (PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending))){
          stopAudio();
          return;
        }

        startAudio(root, role, isNaN(index) ? -1 : index);
      });

      btn.__poAudioBound = true;
    }
  }

  function initAudioEverywhere(lang){
    var roots = getAudioRoots();
    for (var i=0;i<roots.length;i++){
      ensureAudioButtons(roots[i]);
      bindAudioButtons(roots[i]);
      refreshAudioLabels(roots[i], lang || getLang());
    }
  }

  try{
    if (PO_AUDIO_SYNTH && typeof PO_AUDIO_SYNTH.addEventListener === "function"){
      PO_AUDIO_SYNTH.addEventListener("voiceschanged", function(){
        if (PO_AUDIO_STATE.root){
          PO_AUDIO_STATE.voice = pickVoiceForLang(PO_AUDIO_STATE.lang || getLang());
        }
      });
    }
  }catch(e){}

  /* --------------------------------------------------------------------------
   * SLOTS helpers
   * -------------------------------------------------------------------------- */

  function qs(root, sel){
    try{ return root.querySelector(sel); }catch(e){ return null; }
  }

  function setSlotText(root, slot, txt){
    var el = qs(root, '[data-po-slot="'+slot+'"]');
    if (!el) return;
    el.textContent = clampStr(txt);
  }

  function setSlotHTML(root, slot, html){
    var el = qs(root, '[data-po-slot="'+slot+'"]');
    if (!el) return;
    el.innerHTML = protectKeywordsHTML(html);
  }

  function setSlotImg(root, slot, src, alt){
    var el = qs(root, '[data-po-slot="'+slot+'"]');
    if (!el) return;

    var s = clampStr(src);
    var a = clampStr(alt);

    if (!s){
      try{ el.removeAttribute("src"); }catch(e){}
      try{ el.setAttribute("alt",""); }catch(e){}
      try{ el.style.display = "none"; }catch(e){}
      return;
    }

    try{ el.setAttribute("src", s); }catch(e){}
    try{ el.setAttribute("alt", a); }catch(e){}
    try{ el.style.display = ""; }catch(e){}
  }

  function setSlotImgSrc(root, slot, src, alt){
    setSlotImg(root, slot, src, alt);
  }

  function renderList(root, slot, items){
    var el = qs(root, '[data-po-slot="'+slot+'"]');
    if (!el) return;
    var arr = Array.isArray(items) ? items : [];
    var out = [];
    for (var i=0;i<arr.length;i++){
      out.push("<li>" + protectKeywordsHTML(clampStr(arr[i])) + "</li>");
    }
    el.innerHTML = out.join("");
  }

  function renderExampleBox(root, slot, exampleTitle, exampleText){
    var el = qs(root, '[data-po-slot="'+slot+'"]');
    if (!el) return;
    var t = clampStr(exampleTitle);
    var x = clampStr(exampleText);
    if (!t && !x){
      el.innerHTML = "";
      return;
    }
    var html = '<div class="po-lex-example__title"><strong>' + protectKeywordsHTML(t) + '</strong></div>' +
               '<div class="po-lex-example__text">' + protectKeywordsHTML(x) + "</div>";
    el.innerHTML = html;
  }

  function renderWordBlocks(root, slot, blocks){
    var el = qs(root, '[data-po-slot="'+slot+'"]');
    if (!el) return;
    var arr = Array.isArray(blocks) ? blocks : [];
    var out = [];
    for (var i=0;i<arr.length;i++){
      var b = arr[i] || {};
      var h = clampStr(b.head);
      var t = clampStr(b.text);
      out.push(
        '<div class="po-axis-wb">' +
          '<div class="po-axis-wb__h">' + protectKeywordsHTML(h) + '</div>' +
          '<div class="po-axis-wb__t">' + protectKeywordsHTML(t) + '</div>' +
        '</div>'
      );
    }
    el.innerHTML = out.join("");
  }

  /* --------------------------------------------------------------------------
   * IMAGES (Sceau d’Ifẹ̀)
   * -------------------------------------------------------------------------- */

  var IMG_IDEOGRAM_CONCEPT = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_d_If_161_2.png?v=1772899462";
  var IMG_IDEOGRAM_FUNCTION = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_d_If_161_3_copie.png?v=1772899631";
  var IMG_GUIDE_NUMBER_161 = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_161.png?v=1773449115";

  /* --------------------------------------------------------------------------
   * FALLBACKS (FR / EN / ES)
   * -------------------------------------------------------------------------- */

  var FALLBACK_FR = {
    title: "Sceau d’Ifẹ̀",
    kicker: "Katûpirsia 5 — Sceau régulateur de l’Ennéagone spiralé",
    cta_translate: "Proposer une traduction du concept",
    h_def: "Définition opérative",
    chips: ["Idéogramme conceptuel", "Idéogramme fonctionnel", "Fréquence harmonique 161"],
    chip_urls: [ IMG_IDEOGRAM_CONCEPT, IMG_IDEOGRAM_FUNCTION, IMG_GUIDE_NUMBER_161 ],
    def_short:
      "Le Sceau d’Ifẹ̀ est le régulateur des expansions émotionnelles, des ouvertures du cœur qui, mal canalisées, peuvent fragiliser l’équilibre vibratoire.",
    def_long:
      "Le Sceau d’Ifẹ̀ régule les expansions affectives, l’excès d’amour, les débordements émotionnels et les ouvertures intérieures qui menacent de dissoudre le centre. Il agit lors de débordements affectifs, dans les phases de transparition du soi, et face aux éruptions d’amour qui dérèglent les cycles énergétiques internes.\n\n" +
      "Son lien matriciel relie l’ouverture affective humaine à la matrice de syntonie cosmique. Sa nature le situe dans La Katûvýs comme modulateur des expansions affectives incontrôlées. Sa fréquence harmonique, 161, inscrit un axe d’équilibre entre individuation, expansion relationnelle et retour à soi.\n\n" +
      "Il ne restreint pas l’amour. Il le structure dans une spirale de respiration afin que l’ouverture demeure vivante, reliée, incarnée, habitable, sans dispersion ni fusion déséquilibrante.",
    h_features: "Repères structurants",
    h_questions: "Repères d’activation",
    hint_fold: "déplier",
    example_title: "Formulation canonique",
    example:
      "« Ifẹ̀ (161) : je reconnais l’ouverture qui déborde, je lui donne une spirale de respiration, et le cœur retrouve sa tenue dans le lien. »",
    features: [
      "Statut : Sceau régulateur de l’Ennéagone spiralé.",
      "Lien matriciel : relie l’ouverture affective humaine à la matrice de syntonie cosmique.",
      "Fonction principale : régulation des débordements émotionnels, excès d’amour ou d’expansion du soi.",
      "Nature : ni Katûsýs, ni Balakallpa, ni Katûvýsqun — intégré à La Katûvýs comme modulateur des expansions affectives incontrôlées.",
      "Fréquence harmonique : 161.",
      "Type : spirale de modulation affective.",
      "Correspondance entitaire : Ifẹ̀riya."
    ],
    questions: [
      "Si l’amour déborde jusqu’à désorienter : « Ifẹ̀ centre ».",
      "Si la compassion épuise par sur-engagement : « Ifẹ̀ contient ».",
      "Si l’ouverture demande ancrage sans fermeture : « Ifẹ̀ spiralise le cœur ».",
      "Où l’élan du cœur déborde-t-il la capacité de contenance ?",
      "Quelle forme de syntonie redonne cadence à l’émotion sans la nier ?"
    ],
    h_family: "Affinités posœnnoïales",
    family_1:
      "<p><strong>Position dans La Katûvýs :</strong> le Sceau d’Ifẹ̀ s’implante comme modulateur d’équilibre dans les zones d’ouverture. Il agit aux abords des <span translate=\"no\" class=\"po-lex-protect\">Balakallpa</span> affectives et créatives, dans les moments où la vibration du cœur menace de submerger la structure.</p>",
    family_2:
      "<p><strong>Entité isqunienne associée :</strong> <span translate=\"no\" class=\"po-lex-protect\">Ifẹ̀riya</span> accueille, module et transmute les débordements affectifs, qu’ils soient d’origine personnelle, collective ou transgénérationnelle. Elle stabilise l’élan dans un espace vibrant et construit des ponts affectifs sans jamais diluer l’identité.</p>",
    h_wordbuild: "Positionnements & comparaisons",
    word_blocks: [
      {
        head: "Logique du Sceau",
        text:
          "Le Sceau d’Ifẹ̀ ne fonctionne pas comme barrage contre l’émotion. Il agit comme filtre d’intégration, membrane de recentrage et spirale de modulation affective."
      },
      {
        head: "Fonctionnement rituelo-symbolique",
        text:
          "Quand un flux émotionnel dépasse la capacité de contenance, le Sceau d’Ifẹ̀ invite à se relier au centre du cœur vibratoire, à identifier la nature du débordement, à visualiser une sphère spiralo-dilatée, puis à intégrer par respiration profonde et geste enveloppant."
      },
      {
        head: "Axe 161",
        text:
          "La fréquence 161 marque un axe d’équilibre : 1 pour l’individuation, 6 pour l’expansion dans les directions de la relation, 1 pour le retour à soi. Le mouvement affectif devient alors lien respirant plutôt que fusion dissymétrique."
      },
      {
        head: "Portée philosophique",
        text:
          "Le Sceau d’Ifẹ̀ montre que l’amour, comme tout souffle cosmique, demande une structure pour se déployer dans la durée. Il fait danser retenue et élan au lieu de les opposer."
      }
    ],
    word_notes: [
      "Le Sceau d’Ifẹ̀ spiralise l’amour afin qu’il demeure vivant, relié, incarné, offert.",
      "Il stabilise la beauté de l’ouverture sans en briser l’élan.",
      "Ifẹ̀riya agit dans les pratiques relationnelles collectives et les cercles d’écoute.",
      "Mode d’invocation associé : main sur le cœur, respiration lente, cercle d’apaisement."
    ]
  };

  var FALLBACK_EN = {
    title: "Sceau d’Ifẹ̀",
    kicker: "Katûpirsia 5 — Regulatory seal of the spiral Ennéagone",
    cta_translate: "Suggest a translation of the concept",
    h_def: "Operational definition",
    chips: ["Conceptual ideogram", "Functional ideogram", "Harmonic frequency 161"],
    chip_urls: [ IMG_IDEOGRAM_CONCEPT, IMG_IDEOGRAM_FUNCTION, IMG_GUIDE_NUMBER_161 ],
    def_short:
      "Sceau d’Ifẹ̀ regulates emotional expansion, openings of the heart that, when poorly channelled, may weaken vibratory balance.",
    def_long:
      "Sceau d’Ifẹ̀ regulates affective expansion, excess love, emotional overflow, and inner openings that threaten to dissolve the centre. It acts during affective overflow, in phases of transparition of the self, and before eruptions of love that disturb internal energetic cycles.\n\n" +
      "Its matrix link connects human affective openness to the matrix of cosmic syntony. Its nature places it within Katûvýs as a modulator of uncontrolled affective expansion. Its harmonic frequency, 161, inscribes an axis of equilibrium between individuation, relational expansion, and return to self.\n\n" +
      "It does not restrict love. It structures it in a spiral of breathing so that openness remains alive, connected, embodied, inhabitable, without dispersion or unbalanced fusion.",
    h_features: "Structural markers",
    h_questions: "Activation markers",
    hint_fold: "unfold",
    example_title: "Canonical formulation",
    example:
      "“Ifẹ̀ (161): I recognise the opening that overflows, I give it a spiral of breathing, and the heart recovers its steadiness within relation.”",
    features: [
      "Status: regulatory seal of the spiral Ennéagone.",
      "Matrix link: connects human affective openness to the matrix of cosmic syntony.",
      "Main function: regulation of emotional overflow, excess love, or expansion of the self.",
      "Nature: neither Katûsýs, nor Balakallpa, nor Katûvýsqun — integrated into Katûvýs as a modulator of uncontrolled affective expansion.",
      "Harmonic frequency: 161.",
      "Type: spiral of affective modulation.",
      "Entitary correspondence: Ifẹ̀riya."
    ],
    questions: [
      "If love overflows to the point of disorientation: “Ifẹ̀ centres.”",
      "If compassion exhausts through over-engagement: “Ifẹ̀ contains.”",
      "If openness asks for anchoring without closure: “Ifẹ̀ spiralises the heart.”",
      "Where does the movement of the heart overflow the capacity of containment?",
      "What form of syntony restores cadence to emotion without denying it?"
    ],
    h_family: "Posœnnoïal affinities",
    family_1:
      "<p><strong>Position in Katûvýs:</strong> Sceau d’Ifẹ̀ is implanted as a balance modulator within zones of openness. It acts around affective and creative <span translate=\"no\" class=\"po-lex-protect\">Balakallpa</span> when the vibration of the heart threatens to submerge structure.</p>",
    family_2:
      "<p><strong>Associated Isqunian entity:</strong> <span translate=\"no\" class=\"po-lex-protect\">Ifẹ̀riya</span> welcomes, modulates, and transmutes affective overflow, whether personal, collective, or transgenerational. It stabilises the impulse in a vibrant space and builds affective bridges without ever diluting identity.</p>",
    h_wordbuild: "Positions & comparisons",
    word_blocks: [
      {
        head: "Logic of the seal",
        text:
          "Sceau d’Ifẹ̀ does not function as a barrier against emotion. It acts as a filter of integration, a membrane of re-centring, and a spiral of affective modulation."
      },
      {
        head: "Ritual-symbolic functioning",
        text:
          "When an emotional flow exceeds the capacity of containment, Sceau d’Ifẹ̀ invites one to reconnect with the vibratory heart-centre, identify the nature of overflow, visualise a spiralo-dilated sphere, and integrate through deep breathing and an enveloping gesture."
      },
      {
        head: "Axis 161",
        text:
          "Frequency 161 marks an axis of equilibrium: 1 for individuation, 6 for expansion in the directions of relation, 1 for return to self. Affective movement becomes a breathing link rather than asymmetrical fusion."
      },
      {
        head: "Philosophical scope",
        text:
          "Sceau d’Ifẹ̀ shows that love, like every cosmic breath, requires structure in order to unfold through duration. It lets restraint and impulse dance together rather than opposing them."
      }
    ],
    word_notes: [
      "Sceau d’Ifẹ̀ spiralises love so that it remains alive, connected, embodied, offered.",
      "It stabilises the beauty of openness without breaking its momentum.",
      "Ifẹ̀riya acts in collective relational practices and listening circles.",
      "Associated mode of invocation: hand on the heart, slow breathing, circle of appeasement."
    ]
  };

  var FALLBACK_ES = {
    title: "Sceau d’Ifẹ̀",
    kicker: "Katûpirsia 5 — Sello regulador del Ennéagone espiral",
    cta_translate: "Proponer una traducción del concepto",
    h_def: "Definición operativa",
    chips: ["Ideograma conceptual", "Ideograma funcional", "Frecuencia armónica 161"],
    chip_urls: [ IMG_IDEOGRAM_CONCEPT, IMG_IDEOGRAM_FUNCTION, IMG_GUIDE_NUMBER_161 ],
    def_short:
      "Sceau d’Ifẹ̀ regula las expansiones emocionales, las aperturas del corazón que, mal canalizadas, pueden fragilizar el equilibrio vibratorio.",
    def_long:
      "Sceau d’Ifẹ̀ regula la expansión afectiva, el exceso de amor, los desbordamientos emocionales y las aperturas interiores que amenazan con disolver el centro. Actúa durante desbordamientos afectivos, en fases de transparición del yo y frente a erupciones de amor que alteran los ciclos energéticos internos.\n\n" +
      "Su vínculo matricial conecta la apertura afectiva humana con la matriz de sintonía cósmica. Su naturaleza lo sitúa en la Katûvýs como modulador de las expansiones afectivas incontroladas. Su frecuencia armónica, 161, inscribe un eje de equilibrio entre individuación, expansión relacional y retorno a sí.\n\n" +
      "No restringe el amor. Lo estructura en una espiral de respiración para que la apertura permanezca viva, vinculada, encarnada, habitable, sin dispersión ni fusión desequilibrada.",
    h_features: "Referentes estructurantes",
    h_questions: "Referentes de activación",
    hint_fold: "desplegar",
    example_title: "Formulación canónica",
    example:
      "« Ifẹ̀ (161): reconozco la apertura que desborda, le doy una espiral de respiración y el corazón recupera su sostén en el vínculo. »",
    features: [
      "Estatus: sello regulador del Ennéagone espiral.",
      "Vínculo matricial: conecta la apertura afectiva humana con la matriz de sintonía cósmica.",
      "Función principal: regulación de los desbordamientos emocionales, exceso de amor o expansión del yo.",
      "Naturaleza: ni Katûsýs, ni Balakallpa, ni Katûvýsqun — integrado en la Katûvýs como modulador de las expansiones afectivas incontroladas.",
      "Frecuencia armónica: 161.",
      "Tipo: espiral de modulación afectiva.",
      "Correspondencia entitaria: Ifẹ̀riya."
    ],
    questions: [
      "Si el amor desborda hasta desorientar: « Ifẹ̀ centra ».",
      "Si la compasión agota por sobreimplicación: « Ifẹ̀ contiene ».",
      "Si la apertura pide anclaje sin cierre: « Ifẹ̀ spiralise le cœur ».",
      "¿Dónde el impulso del corazón desborda la capacidad de contención?",
      "¿Qué forma de sintonía devuelve cadencia a la emoción sin negarla?"
    ],
    h_family: "Afinidades posœnnoïales",
    family_1:
      "<p><strong>Posición en la Katûvýs:</strong> Sceau d’Ifẹ̀ se implanta como modulador de equilibrio en las zonas de apertura. Actúa en los bordes de las <span translate=\"no\" class=\"po-lex-protect\">Balakallpa</span> afectivas y creativas cuando la vibración del corazón amenaza con sumergir la estructura.</p>",
    family_2:
      "<p><strong>Entidad isquniana asociada:</strong> <span translate=\"no\" class=\"po-lex-protect\">Ifẹ̀riya</span> acoge, modula y transmuta los desbordamientos afectivos, ya sean personales, colectivos o transgeneracionales. Estabiliza el impulso en un espacio vibrante y construye puentes afectivos sin diluir jamás la identidad.</p>",
    h_wordbuild: "Posicionamientos y comparaciones",
    word_blocks: [
      {
        head: "Lógica del sello",
        text:
          "Sceau d’Ifẹ̀ no funciona como barrera contra la emoción. Actúa como filtro de integración, membrana de recentrado y espiral de modulación afectiva."
      },
      {
        head: "Funcionamiento ritual-simbólico",
        text:
          "Cuando un flujo emocional supera la capacidad de contención, Sceau d’Ifẹ̀ invita a reconectar con el centro vibratorio del corazón, identificar la naturaleza del desbordamiento, visualizar una esfera espiralo-dilatada e integrar mediante respiración profunda y gesto envolvente."
      },
      {
        head: "Eje 161",
        text:
          "La frecuencia 161 marca un eje de equilibrio: 1 para la individuación, 6 para la expansión en las direcciones de la relación, 1 para el retorno a sí. El movimiento afectivo se vuelve entonces vínculo respirante en lugar de fusión disimétrica."
      },
      {
        head: "Alcance filosófico",
        text:
          "Sceau d’Ifẹ̀ muestra que el amor, como todo soplo cósmico, requiere estructura para desplegarse en la duración. Hace danzar la contención y el impulso en lugar de oponerlos."
      }
    ],
    word_notes: [
      "Sceau d’Ifẹ̀ espiraliza el amor para que permanezca vivo, vinculado, encarnado, ofrecido.",
      "Estabiliza la belleza de la apertura sin romper su impulso.",
      "Ifẹ̀riya actúa en prácticas relacionales colectivas y círculos de escucha.",
      "Modo de invocación asociado: mano sobre el corazón, respiración lenta, círculo de apaciguamiento."
    ]
  };

  function getFallback(lang){
    var l = normLang(lang) || "fr";
    if (l === "en") return FALLBACK_EN;
    if (l === "es") return FALLBACK_ES;
    return FALLBACK_FR;
  }

  function getAxisLexId(node){
    try{
      return node.getAttribute("data-po-lex-id") || "";
    }catch(e){
      return "";
    }
  }

  function getAxisData(node, lang){
    var l = normLang(lang) || "fr";
    var base = getFallback(l);
    var out = {};
    for (var k in base) out[k] = base[k];

    var lexId = getAxisLexId(node);
    if (lexId){
      var entry = getLexiconEntry(lexId);
      if (entry){
        var termFR = pickTerm(entry, "fr");
        if (termFR) out.title = termFR;

        if (l === "fr"){
          var dsFR = pickDefShort(entry, "fr");
          if (dsFR) out.def_short = dsFR;

          var dlFR = pickDefLong(entry, "fr");
          if (dlFR) out.def_long = dlFR;

          var fFR = pickArray(entry, "fr", "features");
          if (fFR && fFR.length) out.features = fFR;

          var qFR = pickArray(entry, "fr", "questions");
          if (qFR && qFR.length) out.questions = qFR;
        }
      }
    }

    return out;
  }

  function applyToAxis(node, lang){
    var data = getAxisData(node, lang);

    var chipUrls = (data && Array.isArray(data.chip_urls) && data.chip_urls.length) ? data.chip_urls : [
      IMG_IDEOGRAM_CONCEPT, IMG_IDEOGRAM_FUNCTION, IMG_GUIDE_NUMBER_161
    ];

    setSlotImgSrc(node, "title_img", chipUrls[0] || IMG_IDEOGRAM_CONCEPT, data.title || "");

    setSlotText(node, "title", data.title);
    setSlotText(node, "kicker", data.kicker);
    setSlotText(node, "h_def", data.h_def);

    var chips = Array.isArray(data.chips) ? data.chips : [];
    setSlotText(node, "chip_1", chips[0] || "");
    setSlotText(node, "chip_2", chips[1] || "");
    setSlotText(node, "chip_3", chips[2] || "");

    setSlotImgSrc(node, "chip_1_img", chipUrls[0] || IMG_IDEOGRAM_CONCEPT, chips[0] || "Idéogramme conceptuel");
    setSlotImgSrc(node, "chip_2_img", chipUrls[1] || IMG_IDEOGRAM_FUNCTION, chips[1] || "Idéogramme fonctionnel");
    setSlotImgSrc(node, "chip_3_img", chipUrls[2] || IMG_GUIDE_NUMBER_161, chips[2] || "Fréquence harmonique 161");

    setSlotHTML(node, "def_short", clampStr(data.def_short));
    setSlotHTML(node, "def_long", clampStr(data.def_long));

    setSlotText(node, "h_features", data.h_features);
    setSlotText(node, "hint_fold", data.hint_fold);
    renderList(node, "features", data.features);

    setSlotText(node, "h_questions", data.h_questions);
    setSlotText(node, "hint_fold2", data.hint_fold);
    renderList(node, "questions", data.questions);
    renderExampleBox(node, "example_box", data.example_title, data.example);

    setSlotText(node, "h_family", data.h_family);
    setSlotText(node, "hint_fold3", data.hint_fold);
    setSlotHTML(node, "family_1", data.family_1);
    setSlotHTML(node, "family_2", data.family_2);

    setSlotText(node, "h_wordbuild", data.h_wordbuild);
    renderWordBlocks(node, "wordbuild_blocks", data.word_blocks);
    renderList(node, "wordbuild_notes", data.word_notes);

    setSlotText(node, "cta_translate", data.cta_translate);
  }

  function applyAll(lang){
    var activeLang = normLang(lang) || getLang();
    var nodes = document.querySelectorAll(ROOT_SEL);
    for (var i=0;i<nodes.length;i++){
      if (!isThisAxisRoot(nodes[i])) continue;
      applyToAxis(nodes[i], activeLang);
    }
    initAudioEverywhere(activeLang);
  }

  function hasLexiconReady(){
    try{
      if (window.PO_LEXICON_MAP) return true;
      if (Array.isArray(window.PO_LEXICON) && window.PO_LEXICON.length) return true;
      if (window.PO_LEXICON_META && window.PO_LEXICON_META.lexique_simplifie_fr) return true;
    }catch(e){}
    return false;
  }

  function init(){
    var existing = readStoredLang();
    if (!existing){
      storeLang(detectBrowserLang());
    }

    applyAll(getLang());

    window.addEventListener("po:lexicon-ready", function(){
      __PO_PROTECT_RE__ = null;
      applyAll(getLang());
    });

    try{
      var mo = new MutationObserver(function(muts){
        for (var i=0;i<muts.length;i++){
          if (muts[i].type === "attributes" && muts[i].attributeName === "lang"){
            applyAll(getLang());
            notifyLocaleChanged();
            break;
          }
        }
      });
      if (document && document.documentElement){
        mo.observe(document.documentElement, { attributes:true });
      }
    }catch(e){}

    if (!hasLexiconReady()){
      var tries = 0;
      var maxTries = 24;
      var it = setInterval(function(){
        tries++;
        if (hasLexiconReady() || tries >= maxTries){
          clearInterval(it);
          __PO_PROTECT_RE__ = null;
          applyAll(getLang());
        }
      }, 250);
    }
  }

  window.PoKatupirsia5SceauDIfeTextsFR_EN_ES_20260307 = {
    init: init,
    getLang: getLang,
    normLang: normLang,
    setLang: function(raw){
      var l = normLang(raw) || "fr";
      storeLang(l);
      __PO_PROTECT_RE__ = null;
      applyAll(l);
      notifyLocaleChanged();
      return l;
    },
    stopAudio: stopAudio
  };

  window.GoodyTwinLang = window.GoodyTwinLang || {};
  window.GoodyTwinLang.init = init;
  window.GoodyTwinLang.getLang = getLang;
  window.GoodyTwinLang.setLang = function(lang){
    return window.PoKatupirsia5SceauDIfeTextsFR_EN_ES_20260307.setLang(lang);
  };

  if (document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", init);
  }else{
    init();
  }

})();